import * as React from "react";
import type { SVGProps } from "react";
const SvgIconParking = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.73 1.61c-1.1.14-1.98 1.02-2.12 2.15-.04.3-.04 16.18 0 16.48q.11.9.76 1.5.57.56 1.4.65c.28.04 16.18.04 16.46 0 .3-.03.53-.1.8-.24.76-.36 1.26-1.07 1.36-1.92.04-.28.04-16.18 0-16.46-.14-1.15-1-2.02-2.15-2.16-.26-.03-16.25-.03-16.5 0m.1 1.73c-.21.06-.44.3-.5.5-.01.06-.02 2.75-.01 8.21v8.12l.07.13q.12.2.34.32l.1.06h16.34l.13-.07q.2-.12.32-.34l.06-.1V3.83l-.06-.1q-.11-.23-.32-.33l-.13-.08h-8.13c-4.84 0-8.17 0-8.22.02M7.8 5.6c-.26.07-.48.27-.58.52l-.06.13v11.5l.06.13q.13.31.43.46c.14.07.18.08.37.08.17 0 .22-.01.35-.07.18-.08.34-.25.43-.43l.07-.15v-2.06l.01-2.05h2.41c1.54 0 2.5-.01 2.65-.03 1.56-.17 2.75-1.4 2.88-2.99.03-.37.03-1.69 0-2.06q-.1-1.23-.96-2.08c-.52-.51-1.19-.83-1.92-.9-.35-.04-6-.04-6.14 0m1.08 4.01v2.32h2.47c2.72 0 2.61 0 2.92-.16.41-.2.72-.6.81-1.03.05-.24.05-2.01 0-2.26-.09-.43-.4-.82-.8-1.03-.32-.16-.21-.15-2.93-.15H8.88z"
      fill="currentColor"
    />
  </svg>
);
export default SvgIconParking;
